/**
 * AP-36 5.2 — die Ausnahmen mit Knopf „Speichern" (Layout-Konfigurator, Rollen,
 * Plätze je Modul, Zahlungsplan) halten einen Entwurf, den der Baustein nicht
 * kennt. Solange er ungespeichert ist, warnt der Browser beim Schließen oder
 * Neuladen des Tabs — wie bei einer Speicherstelle mit offener Änderung (7.4).
 */
import { useEffect } from 'react'

export function useWarnungBeimVerlassen(aktiv: boolean) {
  useEffect(() => {
    if (!aktiv) return
    const warne = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      // Ältere Browser zeigen die Warnung nur mit gesetztem `returnValue`.
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', warne)
    return () => window.removeEventListener('beforeunload', warne)
  }, [aktiv])
}
